export var compKey = 'locales-picker';
//# sourceMappingURL=key.js.map